export default {"src":"/_next/static/media/SpinalStenosis.64ec514a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};